const config = {
	apiUrl: 'https://followthatfred.com/api'
};
  
  export default config;
